import React from 'react';

import JFormElement from './j_form_element';

const JFormElements = (props) => {
  const { elements } = props;
  return elements.map( e => <JFormElement key={e.hashCode()} element={e} /> );
};

export default React.memo(JFormElements);